import {
  GamesStorageType,
  IPragmaticLiveData,
  LaunchIdToGameLiveDataType
} from '../../types';

type SetPragmaticGamesLiveDataStatePreparator = (args: {
  state: GamesStorageType;
  data: IPragmaticLiveData[];
}) => GamesStorageType;

export const setPragmaticGamesLiveDataStatePreparator: SetPragmaticGamesLiveDataStatePreparator =
  ({ data, state }) => {
    if (!data) {
      return state;
    }
    const newLaunchIdToGameLiveData = data.reduce<LaunchIdToGameLiveDataType>(
      (acc, item) => {
        if (!item.tableId) {
          return acc;
        }
        const launchId =
          state.gamesLiveInfo.innerGameIdToLaunchId[item.tableId];

        if (!launchId) {
          return acc;
        }

        const {
          tableLimits = {},
          tableOpen,
          availableSeats: seatsAvailable,
          currency,
          totalSeatedPlayers
        } = item;
        const { minBet, maxBet } = tableLimits;

        return {
          ...acc,
          [launchId]: {
            minBet,
            maxBet,
            tableOpen,
            seatsAvailable,
            currency,
            totalSeatedPlayers
          }
        };
      },
      state.gamesLiveInfo.launchIdToGameLiveData
    );
    return {
      ...state,
      gamesLiveInfo: {
        ...state.gamesLiveInfo,
        launchIdToGameLiveData: newLaunchIdToGameLiveData
      }
    };
  };
